import '../css/App.css'

export default function ContactUsBtn(){
    return (<div className='common-padding carousel-container'>
        <div>
            <button>
                Contact Us
            </button>
        </div>
    </div>)
}